export type WcsSpinnerMode = 'border' | 'growing';
